import { render, staticRenderFns } from "./DischargeAverageTimeReport.vue?vue&type=template&id=6b9d2c57&scoped=true"
import script from "./DischargeAverageTimeReport.ts?vue&type=script&lang=ts&external"
export * from "./DischargeAverageTimeReport.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d2c57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b9d2c57')) {
      api.createRecord('6b9d2c57', component.options)
    } else {
      api.reload('6b9d2c57', component.options)
    }
    module.hot.accept("./DischargeAverageTimeReport.vue?vue&type=template&id=6b9d2c57&scoped=true", function () {
      api.rerender('6b9d2c57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/reports/DischargeAverageTimeReport/DischargeAverageTimeReport.vue"
export default component.exports